import type { BlockConfigApiBase } from '#layers/block-engine/utils/block/api/config';

export function blockContextIsContentPage({ getRootContext }: Pick<BlockConfigApiBase, 'getRootContext'>) {
	const rootContext = getRootContext();
	return rootContext.pageType === 'detail' || rootContext.pageType === 'listing';
}

export function blockContextIsDetailPage({ getRootContext }: Pick<BlockConfigApiBase, 'getRootContext'>) {
	return getRootContext().pageType === 'detail';
}

export function blockContextIsListingPage({ getRootContext }: Pick<BlockConfigApiBase, 'getRootContext'>) {
	return getRootContext().pageType === 'listing';
}
